import { centerOfMass } from '@turf/turf'
import L from 'leaflet'
import { useMemo } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { Marker } from 'react-leaflet'

import { MarkerCluster } from '@/components/map/marker-cluster'

import { useStyles } from './styles'

export default function FieldsNames({
  features,
  visibility,
  fieldColunmName,
}: {
  features: GeoJSON.Feature[]
  visibility: boolean
  fieldColunmName: string
}) {
  const classes = useStyles()

  const fieldNameMarkers = useMemo(() => {
    if (!visibility) return []
    return features
      .map((feature) => {
        const fieldId = feature.properties?.id
        if (!fieldId) return null

        const field_name = feature.properties?.[fieldColunmName]

        return (
          <Marker
            key={fieldId}
            position={
              centerOfMass(
                feature,
              ).geometry.coordinates.reverse() as L.LatLngTuple
            }
            icon={L.divIcon({
              className: classes.marker,
              html: renderToStaticMarkup(<label>{String(field_name)}</label>),
            })}
          />
        )
      })
      .filter(Boolean)
  }, [features, visibility])

  return (
    <MarkerCluster showCoverageOnHover={false}>
      {fieldNameMarkers}
    </MarkerCluster>
  )
}
